import { Controller } from "@hotwired/stimulus"

// Persists <details open> across reloads so the sidebar layout the user set stays put.
const STORAGE_PREFIX = "plot-planner:section:"

export default class extends Controller {
  static values = { id: String }

  connect() {
    if (!(this.element instanceof HTMLDetailsElement)) return
    if (this.idValue) {
      const stored = this.#read()
      if (stored === "open") this.element.open = true
      else if (stored === "closed") this.element.open = false
      // Seed from HTML on first visit so a future Turbo morph/reconnect
      // that re-applies the HTML `open` attribute doesn't clobber the
      // user's in-session preference before they toggle again.
      else this.#persist()
    }
    this._onToggle = () => this.#persist()
    this.element.addEventListener("toggle", this._onToggle)
  }

  disconnect() {
    if (this._onToggle) this.element.removeEventListener("toggle", this._onToggle)
  }

  #read() {
    try {
      return localStorage.getItem(STORAGE_PREFIX + this.idValue)
    } catch {
      return null
    }
  }

  #persist() {
    if (!this.idValue) return
    try {
      localStorage.setItem(STORAGE_PREFIX + this.idValue, this.element.open ? "open" : "closed")
    } catch {
      // Quota exceeded / privacy mode — non-critical
    }
  }
}
